var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHill1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.75 240.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.75,193.13v47.62H0v-16.49l6.72-1.68c12.79-3.2,38.38-9.59,63.97-16.12,23.69-6.04,47.37-12.19,71.06-13.33Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHill1);
export default __webpack_public_path__ + "static/media/hill1.ec92d48e7941db57e4902bd62c3d8f29.svg";
export { ForwardRef as ReactComponent };